import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// expose libraries if share module
// window.EventEmitter = require("eventemitter3");
// eslint-disable-next-line no-multi-assign
window.$ = window.jQuery = require("jquery");

gsap.registerPlugin(ScrollTrigger);
window.gsap = gsap;
